// Horizontal bar breakdown. Each item: { key?, label, value, valueLabel, sub? }.
// Bars are scaled to the largest value in the set.
export function BreakdownBars({ items = [], emptyText = 'Nessun dato.' }) {
  if (!items.length) return <p className="text-sm text-ink-muted">{emptyText}</p>;
  const max = Math.max(1, ...items.map((i) => i.value || 0));
  return (
    <ul className="flex flex-col gap-3">
      {items.map((it, idx) => (
        <li key={it.key || it.label || idx}>
          <div className="mb-1 flex items-center justify-between gap-3 text-sm">
            <span className="truncate text-ink">{it.label}</span>
            <span className="shrink-0 font-medium tabular-nums text-ink">{it.valueLabel}</span>
          </div>
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-surface-subtle">
            <div className="h-full rounded-full bg-ink" style={{ width: `${Math.max(2, ((it.value || 0) / max) * 100)}%` }} />
          </div>
          {it.sub && <p className="mt-1 text-xs text-ink-faint">{it.sub}</p>}
        </li>
      ))}
    </ul>
  );
}
